const SET_LOCALE = 'SET_LOCALE';
export default SET_LOCALE;